import { render } from "./More.vue?vue&type=template&id=635f2b0e&scoped=true"
import script from "./More.vue?vue&type=script&lang=js"
export * from "./More.vue?vue&type=script&lang=js"

import "./More.vue?vue&type=style&index=0&id=635f2b0e&scoped=true&lang=css"

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-6763a87ef6/0/cache/vue-loader-npm-17.4.2-00674d01e5-ffbe3e848e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635f2b0e"]])

export default __exports__